export default "__VITE_ASSET__QWanFg48__"